<template>
  <el-main>
    <events />
  </el-main>
</template>

<script>
  // components
  import Events from './events/Events.vue';

  export default {
    name: 'PageContent',
    components: {
      Events
    },
  }
</script>
